import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import './Categorypic.css'
import category1 from '../../assets/category/category_1.png'
import category2 from '../../assets/category/category_2.png'
import category3 from '../../assets/category/category_3.png'
import category4 from '../../assets/category/category_4.png'
import category5 from '../../assets/category/category_5.png'
import category6 from '../../assets/category/category_6.png'
import category7 from '../../assets/category/category_7.png'
import category8 from '../../assets/category/category_8.png'
import category9 from '../../assets/category/category_9.png'
import category10 from '../../assets/category/category_10.png'
import { getColor, lettercolor } from '../../utility/lettercolor'
import { Modal } from 'react-bootstrap'

const categoryImages = {
  1: category1,
  2: category2,
  3: category3,
  4: category4,
  5: category5,
  6: category6,
  7: category7,
  8: category8,
  9: category9,
  10: category10
}
const EMPTY_OBJ = {}
const Categorypic = ({isOpenModal,categoryID }) => {
const [ismodalopen,setIsModalOpen]=useState(false)
  const categorydataarr = useSelector(
    (state) => state?.trackhrcategory?.CategoryDataArr || EMPTY_OBJ
  )

  

  const getName = (id) => {
    const value = categorydataarr?.[id]
    if (!value) return ''
    return value.split('$-')[0]?.[0] || ''
  }
const getCategoryFullName=(categoryID)=>{
        for (const key in categorydataarr) {
            if (categoryID == key) {
                var categoryName = categorydataarr[categoryID].split('$')[0]
                // console.log(categoryName)
                return categoryName
            }
        }
    }
   const getCategorysub=(categoryID)=>{
        for (const key in categorydataarr) {
            if (categoryID == key) {
                var categoryName = categorydataarr[categoryID].split('$')[2]
                // console.log(categoryName)
                return categoryName
            }
        }
    }
  const getResponse = (id) => {
    const value = categorydataarr?.[id]


    if (!value) return null


    if (categoryImages[id]) {
      return <img src={categoryImages[id]}   className="category" alt="category" />
    }

    return (
      <>
      <div
        className="category"
        id="categoryBox"
        style={{ backgroundColor: getColor(id, categorydataarr) }}
        onClick={ ()=>{
if(isOpenModal){
  setIsModalOpen(true)
}
        }}
      >
        <span style={{ color: lettercolor(id, categorydataarr) }}>
          {getName(id)}
        </span>
      </div>
      </>
    )
  }

  return <>{getResponse(categoryID)}
    {
        ismodalopen &&  <Modal centered size="sm" id="categoryModal" animation={true} show={ismodalopen}  onHide={()=>setIsModalOpen(false)}> {/* backdrop="static" keyboard={false} */}
                    <Modal.Body>
                        <div className="CategoryMainDiv" >
                            <div className="categoryImage" style={{display:"flex" , justifyContent:"center", alignContent:"center",width:"60px",height:"60px"}}>
                               
                                {
                                    getResponse(categoryID)
                                }
                            </div>
                            <h5 style={{fontWeight:"700"}}>{getCategoryFullName(categoryID)}</h5>
                            <h6 style={{fontSize:"12px"}}>{getCategorysub(categoryID)}</h6>
                        </div>
                    </Modal.Body>
                </Modal>
      }
  
  </>
}

export default Categorypic
